module.exports = __webpack_public_path__ + "static/media/appointment-request-cancelled.a23d85eb.svg";